import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'

export default {
  name: 'PanelRequest',
  props: ['selectedSolicitacao'],
  computed: {
    statusText: function () {
      return ['Aprovado', 'Reprovado', 'Pendente', 'Pendência de Ajuste', 'Aprovado com Pend.'][this.selectedSolicitacao.status]
    },
    statusColor: function () {
      return ['#30a75f', '#db3939', '#f6b535', '#fe781e', '#2798e3'][this.selectedSolicitacao.status]
    }

  },
  data () {
    return {
      dataRequest: []
    }
  },
  methods: {
    onLoad () {
      RequestsRepository.GetAll()
        .then(Response => {
          this.$refs.painelRequest.LoadAllByData(Response)
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/panelRequest/panelRequest.js